<template>
  <div class="pets-registration row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
      <div class="col-lg-9 pets-rgistration-container">
        <form @submit.prevent="petRegistretion" novalidate>
          <div class="row">
            <div class="col-md-12 pets-registration-header">
              <div class="row">
                <div class="col-md-4">
                  <div class="pet-image">
                    <img  class="img-circle img-responsive" src="../../assets/img/icons/empty-image-no-border.svg" alt="Default Pet Image">
                  </div>
                </div>
                <div class="col-md-4">
                  <span class="text-danger">{{translation.registration.requiredSymbol}}</span>
                  <p class="text-left">{{translation.updateProfile.country}}</p>
                  <select v-model="pet.countryCode" @change="changedForm">
                    <option v-for="country in countries" :value="country.code">{{country.name}}</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <span class="text-danger">{{translation.registration.requiredSymbol}}</span>
                  <p class="text-left">{{translation.petProfile.identNumber}}</p>
                  <input type="text" class="form-control" id="petId" v-model="pet.petNumber" disabled>
                </div>
              </div>
            </div>
            <div class="col-md-12 description-container">
              <div class="row text-left">
                <div class="col-md-6">
                  <h3>{{translation.pets.description}}</h3>
                </div>
                <div class="col-md-6">
                  <p class="text-left">
                    <span>{{translation.registration.requiredField}}</span>
                    <span class="text-danger">{{translation.registration.requiredSymbol}}</span>
                    <span>{{translation.registration.areRequired}}</span>
                  </p>
                  <p v-if="errors.length" class="text-left text-danger">
                    <b>{{translation.registration.correct}}</b>
                    <ul class="list-group">
                      <li class="text-danger text-left list-group-item list-group-item-light" v-for="error in errors">{{ error }}</li>
                    </ul>
                  </p>
                  <p v-if="update" class="text-left text-success">
                    <b>{{translation.pets.createPet}}</b>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" @change="changedForm" class="form-control" name="petName" v-model="pet.petName" :placeholder="translation.pets.name + translation.registration.requiredSymbol">
                    <label for="petName">{{translation.pets.name + translation.registration.requiredSymbol}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" @change="changedForm" class="form-control" name="petSpecies" v-model="pet.petSpecies" :placeholder="translation.pets.species + translation.registration.requiredSymbol">
                    <label for="petSpecies">{{translation.pets.species + translation.registration.requiredSymbol}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" @change="changedForm" class="form-control" name="petBreed" v-model="pet.petBreed" :placeholder="translation.pets.breed + translation.registration.requiredSymbol">
                    <label for="petBreed">{{translation.pets.breed + translation.registration.requiredSymbol}}</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" @change="changedForm" class="form-control" name="petSex" v-model="pet.petSex" :placeholder="translation.pets.sex + translation.registration.requiredSymbol">
                    <label for="petSex">{{translation.pets.sex + translation.registration.requiredSymbol}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="date" @change="changedForm" class="form-control" name="petBirthDate" v-model="pet.petBirthDate" :placeholder="translation.pets.birthDate + translation.registration.requiredSymbol">
                    <label for="petBirthDate">{{translation.pets.birthDate + translation.registration.requiredSymbol}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" @change="changedForm" class="form-control" name="petCoat" v-model="pet.petCoat" :placeholder="translation.pets.coat + translation.registration.requiredSymbol">
                    <label for="petCoat">{{translation.pets.coat + translation.registration.requiredSymbol}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 pets-identification">
              <div class="row text-left">
                <div class="col-md-12 text-left">
                  <h3>{{translation.pets.identification}}</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" class="form-control" name="microchip" v-model="pet.microchip" :placeholder="translation.pets.microchip">
                    <label for="microchip">{{translation.pets.microchip}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="date" class="form-control" name="dateMicrochipping" v-model="pet.dateMicrochipping" :placeholder="translation.pets.dateMicrochipping">
                    <label for="dateMicrochipping">{{translation.pets.dateMicrochipping}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" class="form-control" name="microchipping" v-model="pet.microchipping" :placeholder="translation.pets.microchipping">
                    <label for="microchipping">{{translation.pets.microchipping}}</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" class="form-control" name="tattooNumber" v-model="pet.tattooNumber" :placeholder="translation.pets.tattooNumber">
                    <label for="tattooNumber">{{translation.pets.tattooNumber}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="date" class="form-control" name="tattooDate" v-model="pet.tattooDate" :placeholder="translation.pets.tattooDate">
                    <label for="tattooDate">{{translation.pets.tattooDate}}</label>
                  </div>
                </div>
                <div class="col-md-4"></div>
              </div>
            </div>
            <div class="col-md-12 pets-pedigree text-left">
              <div class="row">
                <div class="col-md-12">
                  <h3>{{translation.pets.pedigree}}</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" class="form-control" name="kennel" v-model="pet.kennel" :placeholder="translation.pets.kennel">
                    <label for="kennel">{{translation.pets.kennel}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" class="form-control" name="mother" v-model="pet.mother" :placeholder="translation.pets.mother">
                    <label for="mother">{{translation.pets.mother}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group text-left">
                    <input type="text" class="form-control" name="father" v-model="pet.father" :placeholder="translation.pets.father">
                    <label for="father">{{translation.pets.father}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 add-pet-button">
              <button type="submit" class="btn middle-pet-button">{{translation.button.add}}</button>
              <button class="btn mobile-pet-button"><img class="img-responsive" src="../../assets/img/icons/add-pet-mobile-icon.svg"/></button>
            </div>
          </div>
        </form>
        <div v-if='showUnsaveModal' class="modal text-left">
          <div class="modal-content modal-small" >
            <div class="modal-header">
              <h3>{{translation.modalText.modalHeader}}</h3>
              <span class="close-modal" @click="hideUnsaveModal">&times;</span>
            </div>
            <div class="modal-body modal-body-small">
              <p>{{translation.modalText.userWarning}}</p>
              <p>{{translation.modalText.modalQuestion}}</p>
            </div>
            <div class="modal-footer">
              <button class=" modal-button-remove  close-modal-button" @click="hideUnsaveModal">{{translation.button.noDelete}}</button>
              <button type="submit" class=" modal-button-add" @click="petRegistretion">{{translation.modalText.modalSaveButton}}</button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import countries from '../../js/countries/countries.js';
export default {
  data(){
    return {
      translation: null,
      countries: countries,
      previewImage:null,
      update: false,
      uploadPercentage: 0,
      uploadMessage: '',
      loader: false,
      chenagedInput: false,
      showUnsaveModal: false,
      userPath: null,
      pet: {
        countryCode: 'BG',
        petNumber: '',
        petName: '',
        petSpecies: '',
        petBreed: '',
        petSex: '',
        petBirthDate: '',
        petCoat: '',
        microchip: '',
        dateMicrochipping: '',
        microchipping: '',
        tattooNumber: '',
        tattooDate: '',
        kennel: '',
        mother: '',
        father: ''
      },
      errors:[],
      selected: 'BG'
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.chenagedInput) {
      this.showUnsaveModal = true;
      this.userPath = this.$router.history.pending.fullPath;
    }else {
      this.showUnsaveModal = false;
      next();
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.header.add;
    this.loader = true;
    var self = this;
    if (localStorage.getItem('userLoggedIn') != undefined) {
      if ( localStorage.getItem('userLoggedIn') == true
        || localStorage.getItem('userLoggedIn') == 'true') {
        axios.get('get-pet-number')
          .then(function(response){
              self.loader = false;
              self.pet.petNumber = response.data.result.petNumber
            })
          .catch(err => console.error(err))
      }
    }else {
      self.$router.push({ name: 'home', params: { lang: window.lang } })
    }
  },
  components: {
  },
  methods: {
    changedForm: function(){
      this.chenagedInput = true;
    },
    validate: function (e) {
      this.errors = [];
      if (!this.pet.petName) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.pets.name + '" ' +
          this.translation.registration.required
        );
      }
      if (!this.pet.petSpecies) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.pets.species + '" ' +
          this.translation.registration.required
        );
      }
      if (!this.pet.petBreed) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.pets.breed + '" ' +
          this.translation.registration.required
        );
      }
      if (!this.pet.petSex) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.pets.sex + '" ' +
          this.translation.registration.required
        );
      }
      if (!this.pet.petBirthDate) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.pets.birthDate + '" ' +
          this.translation.registration.required
        );
      }
      if (!this.pet.petCoat) {
        this.errors.push(
          this.translation.registration.field + ' "' +
          this.translation.pets.coat + '" ' +
          this.translation.registration.required
        );
      }
      if (!this.errors.length) {
        return true;
      }

      e.preventDefault();
    },
    hideUnsaveModal: function(){
      this.showUnsaveModal = false;
      this.nextPage();
    },
    nextPage: function(){
      this.chenagedInput = false;
      if (this.userPath) {
        this.$router.push(this.userPath);
      }
    },
    petRegistretion: function (e){
      this.showUnsaveModal = false;
      if (this.validate(e)) {
        this.loader = true;
        var formData = this.toFormData(this.pet);
        var self = this;
        axios.post('pets-create-passport', formData)
        .then(function(response){
          self.loader = false;
          self.update = true;
          self.showUnsaveModal = false;
          self.chenagedInput = false;
          if (self.userPath) {
            self.$router.push(self.userPath);
          }
          if (response.data.success && response.data.result != null) {
            var checkError = response.data.result.serverMessage;
            if (checkError == 'petName') {
              self.errors.push(self.translation.serverError.petName);
            }else if (checkError == 'petNameLengt') {
              self.errors.push(self.translation.serverError.petNameLengt);
            }else if (checkError == 'petNameSymbol') {
              self.errors.push(self.translation.serverError.petNameSymbol);
            }else if (checkError == 'emptyPetSpecies') {
              self.errors.push(self.translation.serverError.emptyPetSpecies);
            }else if (checkError == 'petSpeciesSymbol') {
              self.errors.push(self.translation.serverError.petSpeciesSymbol);
            }else if (checkError == 'emptyPetBreed') {
              self.errors.push(self.translation.serverError.emptyPetBreed);
            }else if (checkError == 'petBreedSymbol') {
              self.errors.push(self.translation.serverError.petBreedSymbol);
            }else if (checkError == 'emptyPetSex') {
              self.errors.push(self.translation.serverError.emptyPetSex);
            }else if (checkError == 'petSexSymbol') {
              self.errors.push(self.translation.serverError.petSexSymbol);
            }else if (checkError == 'emptyPetBirthDay') {
              self.errors.push(self.translation.serverError.emptyPetBirthDay);
            }else if (checkError == 'petBirthDateSymbol') {
              self.errors.push(self.translation.serverError.petBirthDateSymbol);
            }else if (checkError == 'emptyPetCoat') {
              self.errors.push(self.translation.serverError.emptyPetCoat);
            }else if (checkError == 'petCoatSymbol') {
              self.errors.push(self.translation.serverError.petCoatSymbol);
            }
            else if (checkError == 'petIsRegistrated') {
              self.errors.push(self.translation.serverError.petIsRegistrated);
              self.update = false;
            }
          }else {
            self.$bus.$emit('createPet', true);
            self.pet;
            self.update = true;
            self.$router.push('/pets-home');
          }
        })
        .catch(err => err)
      }

      },
      toFormData: function (obj){
        var form_data = new FormData();
        for (var key in obj) {
          form_data.append(key,obj[key]);
        }
        return form_data;
      },
    uploadImage(e){
      this.loader = true;
        const image = e.target.files[0];
        var self = this;
        let fd= new FormData();
        const reader = new FileReader();
        if (image != undefined) {
          if (image.name.match(/.(jpg|jpeg|png|gif)$/i)) {
          reader.readAsDataURL(image);
          reader.onload = e =>{
            this.previewImage = e.target.result;
          };
          fd.append('images[]', image)
          fd.append('createFolder', 'pets')
          fd.append('petNumber', this.pet.petNumber)
          axios.post('upload-image', fd,{
            onUploadProgress: function( progressEvent ) {
              self.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total) * 100 ) );
            }
          })
          .then(resp => {
             self.loader = false;
             self.pet.petAvatar = resp.data
             self.$bus.$emit('changeThumb', true)
          })
        }else {
          self.errors.push(self.translation.errors.imageError)
        }
      }
    },
    removeImage(){
      this.loader = true;
      var self = this;
      axios.post('delete-pets-image')
      .then(function(){
        self.loader = false;
        self.previewImage = null;
        self.uploadPercentage = 0;
        self.uploadMessage = '';
        self.$bus.$emit('changeThumb', true)
      })
    }

  }
}
</script>

<style>
.pets-registration {

  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  max-height: 100%;

  background-position: center;
  background-size: cover;
  min-height: 100vh;
}
.pets-registration .pets-registration-header{
  background: #EEEEEE;
  padding: 3em;
  position: relative;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
}
.pets-registration .description-container,
.pets-registration .pets-identification,
.pets-registration  .pets-pedigree {
  background: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
  padding: 1em;
  margin-bottom: 2em;
}
.pets-registration .pets-identification,
.pets-registration  .pets-pedigree {
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
}
.pets-registration .description-container p{
  margin-top: 1em;
}
.pets-registration .pets-rgistration-container{
  margin-top: 13em;
  margin-bottom: 5em;
}
.pets-registration .pets-rgistration-container h3{
  color: #3057B0;
}
.add-pet-button{
  position: fixed;
  bottom: 2em;
  width: 100%;
  left: 0;
  right:0;
}
.add-pet-button .middle-pet-button{
  background: #FE7154;
  padding: .5em;
  padding-left: 1em;
  margin-bottom: 1em;
  padding-right: 1em;
  border-radius: 2em;
  color: #fff;
}
.mobile-pet-button{
  display: none;
}
.pets-registration .pets-registration-header .col-md-4:first-of-type{
    position: relative;
}
.pets-registration .pet-image img{
  width: 10em;
  display: inline-block;
  border: 4px solid #3057B0;
  position: absolute;
  top: -9em;
  left: 0;
  right: 0;
}
.pets-registration .form-group{
  position: relative;
  margin-top: 2em;
}
.pets-registration input[type=text],
.pets-registration input[type=password],
.pets-registration input[type=email],
.pets-registration input[type=date],
.pets-registration select
{
 color: #707070!important;
 background: none!important;
 border: none!important;
 border-radius: 0!important;
 outline: none!important;
 border-bottom: 2px solid #707070!important;
 width: 100%;
 outline: none!important;
 box-shadow: none;
}
.pets-registration label {
 display: none;
}
.pets-registration input[type=text]:focus,
.pets-registration input[type=password]:focus,
.pets-registration input[type=email]:focus,
.pets-registration input[type=date]:focus
{
 border-bottom: 2px solid #3057B0!important;
 outline:0px !important;
 -webkit-appearance:none;
 box-shadow: none !important;
}
.pets-registration input[type=text]:focus + label ,
.pets-registration input[type=password]:focus + label,
.pets-registration input[type=email]:focus + label,
.pets-registration input[type=date]:focus + label
{
  display: block;
  position: absolute;
  bottom: 2em;
  color: #212121!important;
  font-size: 1em;
}
.pets-registration input[type=text]:focus::-webkit-input-placeholder,
.pets-registration input[type=password]:focus::-webkit-input-placeholder,
.pets-registration input[type=email]:focus::-webkit-input-placeholder,
.pets-registration input[type=date]:focus::-webkit-input-placeholder
{
 color:transparent;
}
.pets-registration input[type=text]::-moz-placeholder
.pets-registration input[type=password]:focus::-moz-placeholder
.pets-registration input[type=email]:focus::-moz-placeholder,
.pets-registration input[type=date]:focus::-moz-placeholder {
 color:transparent;
}
.pets-registration input[type=text]:focus::-moz-placeholder
.pets-registration input[type=password]:focus::-moz-placeholder
.pets-registration input[type=email]:focus::-moz-placeholder,
.pets-registration input[type=date]:focus::-moz-placeholder {
  color:transparent;
}
.pets-registration input[type=text]:focus::-ms-input-placeholder
.pets-registration input[type=password]:focus::-ms-input-placeholder
.pets-registration input[type=email]:focus::-ms-input-placeholder,
.pets-registration input[type=date]:focus::-ms-input-placeholder {
 color:transparent;
}
.pets-registration .pets-registration-header select {
  padding: .25em;
}
@media (max-width:1024px) {
  .mobile-pet-button {
    display: block;
    display: inline-block;
    background: transparent;
  }
  .add-pet-button .middle-pet-button{
    display: none;
  }
  .add-pet-button {
    text-align: right;
    bottom: 9em;
  }
  .pets-registration .pets-rgistration-container{
    margin-bottom: 15em;
  }
  .pets-registration .pet-image img{
    position: relative;
  }
}
@media (max-width:768px) {
  .add-pet-button {
    text-align: right;
    bottom: 8em;
  }
  .pets-registration .pet-image img{
    top: 0;
  }
}
</style>
